<template>
  <!-- 新建工单-工单头部部分 -->
  <div>
    <el-form
      :model="workOrderHeader"
      :rules="workOrderHeaderRelues"
      ref="workOrderHeaderFormRef"
      inline
      size="mini"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="部门" prop="selectDepartment">
            <!-- 部门 -->
            <el-select
              v-model="workOrderHeader.selectDepartment"
              placeholder="请选择部门"
            >
              <el-option
                v-for="(item, index) in departmentList"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工单编号" prop="XXXXXXXX">
            <el-input
              v-model="workOrderHeader.number"
              disabled="isDisabled"
              placeholder="自动生成"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="制单日期" prop="createTime">
            <el-date-picker
              disabled="isDisabled"
              style="padding-left: 10px;"
              v-model="workOrderHeader.createTime"
              type="date"
              size="large"
              placeholder="制单日期"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>

          <!--        <el-form-item label="状态" prop="XXXXXXXX">
            <el-input v-model="workOrderHeader.status_change" disabled="isDisabled" >
            </el-input>
        </el-form-item> -->
        </el-col>

        <el-col :span="24">
          <el-form-item label="机台" prop="machineId">
            <!-- 机台 -->
            <el-select
              v-model="workOrderHeader.machineId"
              placeholder="请选择机台"
            >
              <el-option
                v-for="(item, index) in machineList"
                :key="index"
                :label="item.number"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="胚布编号" prop="number_change">
            <el-input
              v-model="workOrderHeader.number_change"
              disabled="isDisabled"
              placeholder="请用右侧选择按钮"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="胚布名称" prop="name_change">
            <el-input
              v-model="workOrderHeader.name_change"
              disabled="isDisabled"
              placeholder="请用右侧选择按钮"
            >
            </el-input>
            <el-button
              type="primary"
              size="mini"
              @click="$refs.materialSelect.show()"
            >
              选择胚布
            </el-button>
          </el-form-item>

          <!-- 220405 liuqy: 提交工单前，不显示"上机状态"。 -->
          <!--        <el-form-item label="上机状态" prop="XXXXXXXX">
            <el-input v-model="workOrderHeader.workStatus" disabled="isDisabled" placeholder="准备中" >
            </el-input>
        </el-form-item> -->
        </el-col>

        <el-col :span="24">
          <el-tooltip
            class="item"
            effect="dark"
            content="单位: 分幅之间用x分割，如300x300"
            placement="right"
          >
            <el-form-item label="幅宽" prop="combs">
              <el-input
                v-model="workOrderHeader.combs"
                placeholder="例: 300x300"
                @keydown.native="handleInput_combs"
                @change="meterWeightCountChange()"
              >
                <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                  >厘米</i
                >
              </el-input>
            </el-form-item>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="根据幅宽计算"
            placement="right"
          >
            <el-form-item label="幅数" prop="combsCount">
              <el-input
                disabled="isDisabled"
                v-model="workOrderHeader.combsCount"
                type="number"
                placeholder="0.00"
              >
                <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                  >幅</i
                >
              </el-input>
            </el-form-item>
          </el-tooltip>

          <el-form-item label="针密" prop="density">
            <el-input
              v-model="workOrderHeader.density"
              type="number"
              placeholder="请输入内容"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >针/厘米</i
              >
            </el-input>
          </el-form-item>

          <el-form-item label="车速" prop="speed">
            <el-input
              v-model="workOrderHeader.speed"
              type="number"
              placeholder="请输入内容"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >转/分钟</i
              >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="平方克重" prop="squareGrams">
            <el-input
              v-model="workOrderHeader.squareGrams"
              @change="meterWeightCountChange()"
              @keydown.native="handleInput2"
              placeholder="请输入内容"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >克/平方米</i
              >
            </el-input>
          </el-form-item>

          <el-form-item label="匹长" prop="dropClothLength">
            <el-input
              v-model="workOrderHeader.dropClothLength"
              type="number"
              placeholder="请输入正整数"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >米</i
              >
            </el-input>
          </el-form-item>
          <el-tooltip
            class="item"
            effect="dark"
            content="单位: 米. 生产长度(C) =生产重量(E)/(总幅宽(AxB)*平方克重(D)=(E*100*1000)/((A+B)*D)"
            placement="left"
          >
            <el-form-item label="生产长度" prop="predictProducedLength">
              <el-input
                v-model="workOrderHeader.predictProducedLength"
                @change="meterWeightCountChange()"
                @keydown.native="handleInput2"
                placeholder="请输入内容"
              >
                <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                  >米</i
                >
              </el-input>
            </el-form-item>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="单位: 千克. 生产重量(E) = 总幅宽(AxB)*目标产量(C)*平方克重(D) = (A+B)/100*C*D/1000"
            placement="left"
          >
            <el-form-item label="生产重量" prop="predictWeight">
              <el-input
                v-model="workOrderHeader.predictWeight"
                @change="meterWeightCountChange2()"
                @keydown.native="handleInput2"
                placeholder="0.00"
              >
                <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                  >千克</i
                >
              </el-input>
            </el-form-item>
          </el-tooltip>
        </el-col>

        <el-col :span="24">
          <el-form-item label="组织纱丝号" prop="silkNumber">
            <el-input
              v-model="workOrderHeader.silkNumber"
              placeholder="例: 20Dx20D"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="针数" prop="threadCount">
            <el-input
              v-model="workOrderHeader.threadCount"
              @keydown.native="handleInput2"
              placeholder="请输入内容"
            >
            </el-input>
          </el-form-item>

          <!-- <el-form-item label="目数" prop="meshCount">
					    <el-input v-model="workOrderHeader.meshCount" type="number" placeholder="请输入正整数">
					    </el-input>
					</el-form-item> -->

          <el-form-item label="完成米数 " prop="nowProducedLength">
            <el-input
              v-model="workOrderHeader.nowProducedLength"
              disabled="isDisabled"
              type="number"
              placeholder="0.00"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >米</i
              >
            </el-input>
          </el-form-item>

          <el-form-item label="完成重量" prop="nowWeight">
            <el-input
              v-model="workOrderHeader.nowWeight"
              type="number"
              disabled="isDisabled"
              placeholder="0.00"
            >
              <i slot="suffix" style="font-style:normal;color:dodgerblue;"
                >千克</i
              >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注" prop="XXXXXXXX">
            <el-input
              v-model="workOrderHeader.remark"
              placeholder="请输入内容"
              style="width: 970px;height: 150px;"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 物料选择 弹框 -->
    <material-select ref="materialSelect" @update="updatePeiBuDialog()" />
  </div>
</template>

<script>
import { MaterialSelect } from "../../../../../components/peiBuSelect";

export default {
  components: {
    MaterialSelect,
  },
  props: {
    machineList: {
      type: Array,
      default() {
        return [
          {
            id: "1",
            number: "001",
          },
        ];
      },
    },
  },
  data() {
    var amountruler = (rules, value, cb) => {
      const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/;
      if (ruler.test(value)) {
        return cb();
      }
      cb(new Error("请输入大于0的正整数"));
    };
    var amountMax = (rules, value, cb) => {
      if (Number(value) <= 20000000) {
        return cb();
      }
      cb(new Error("最大值不能超过20000000"));
    };

    // 非负浮点数 检测
    var floatCheck = (rules, value, cb) => {
      const ruler = /^\d+(\.\d+)?$/;
      if (ruler.test(value)) {
        return cb();
      }
      cb(new Error("请输入非负浮点数"));
    };

    //大于0的浮点数
    var floatMoreThenZero = (rules, value, cb) => {
      const ruler = /^([1-9]\d*)(\.\d{1,6})?$|^0\.\d{1,6}?$/;
      if (ruler.test(+value)) {
        return cb();
      }
      cb(new Error("请输入大于0的数"));
    };

    return {
      workOrderHeader: {
        materialId: 0, //物料id
        number_change: "", //必填项，变化后的 胚布编号。
        name_change: "", //必填项，变化后的 胚布名称。
        // ---------------------------------------
        selectDepartment: "生产部", // 选中的 工厂名称
        machineId: "", // 选中的 机台编号
        // ---------------------------------------
        craftsheet: {}, // 梳节信息
        createTime: new Date().getTime(), // 创建时间/制单日期 220405 liuqy: 不可编辑，提交时自动生成。
        density: Math.round(0).toFixed(2), // 密度，针密？
        meshCount: 0, // 目数
        meterWeight: "", // 测量米重 = 理论重量
        nowWeight: "",
        predictWeight: "",
        predictProducedLength: Math.round(0).toFixed(2), // 目标产量
        speed: Math.round(0).toFixed(1), // 车速?
        squareGrams: Math.round(0).toFixed(2), // 平方克, 计算克数? 要有初始值
        status_change: "待提交",
        threadCount: Math.round(0).toFixed(1), // 针数
      },
      // 部门下拉选择框--sta
      departmentList: [
        {
          label: "生产部",
          value: "X",
        },
      ],
      // 部门下拉选择框--end
      workOrderHeaderRelues: {
        combs: [
          {
            required: true,
            message: "输入：单幅x单幅",
            trigger: "blur",
          },
        ],
        combsCount: [
          {
            required: true,
            message: "请输入幅数",
            trigger: "blur",
          },
          {
            validator: amountruler,
            trigger: "blur",
          },
          {
            validator: amountMax,
            trigger: "blur",
          },
        ],
        createTime: [
          {
            required: true,
            message: "请选择制单日期",
            trigger: "blur",
          },
        ],
        density: [
          {
            required: true,
            message: "请输入针密",
            trigger: "blur",
          },
          {
            validator: floatMoreThenZero,
            trigger: "blur",
          },
        ],
        dropClothLength: [
          {
            required: true,
            message: "请输入匹长",
            trigger: "blur",
          },
          {
            validator: amountruler,
            trigger: "blur",
          },
          {
            validator: amountMax,
            trigger: "blur",
          },
        ],
        machineId: [
          {
            message: "请输入机台",
            trigger: "blur",
          },
        ],
        meshCount: [
          // { required: true, message: '请输入目数', trigger: 'blur' },
          // {
          //     validator: amountruler,
          //     trigger: 'blur'
          // },
          // {
          //                       validator: amountMax,
          //                       trigger: 'blur'
          //                   }
        ],
        // meterWeight: [{ required: true, message: '请输入理论重量', trigger: 'blur' },
        //             { validator: floatCheck, trigger: 'blur' }],
        name_change: [
          {
            required: true,
            message: "请输入胚布名称",
            trigger: "blur",
          },
        ],
        // nowProducedLength: [{ required: true, message: '请输入已完成(米)', trigger: 'blur' },
        //      { validator: amountruler, trigger: 'blur' }, { validator: amountMax, trigger: 'blur' }],
        number_change: [
          {
            required: true,
            message: "请输入胚布编号",
            trigger: "blur",
          },
        ],
        predictWeight: [
          {
            required: true,
            message: "请输入目标产量",
            trigger: "blur",
          },
          {
            validator: floatMoreThenZero,
            trigger: "blur",
          },
        ],
        predictProducedLength: [
          {
            required: true,
            message: "请输入目标产量",
            trigger: "blur",
          },
          {
            validator: floatMoreThenZero,
            trigger: "blur",
          },
        ],
        selectDepartment: [
          {
            required: true,
            message: "请选择部门",
            trigger: "blur",
          },
        ],
        // silkNumber: [{ required: true, message: '请输入组织纱丝号', trigger: 'blur' }],
        speed: [
          {
            required: true,
            validator: floatMoreThenZero,
            message: "请输入大于0的数",
            trigger: "blur",
          },
        ],
        squareGrams: [
          {
            required: true,
            message: "请输入大于0的数",
            trigger: "blur",
            validator: floatMoreThenZero,
          },
          {
            validator: floatCheck,
            trigger: "blur",
          },
        ],
        threadCount: [
          // { required: true, message: '请输入针数', trigger: 'blur' },
          // {
          //     validator: floatCheck,
          //     trigger: 'blur'
          // }
        ],
      },
    };
  },
  methods: {
    // 外部调用，获取生产单头部
    getWorkOrderHeader() {
      const cloneHeader = this._.cloneDeep(this.workOrderHeader);
      // cloneHeader.amount = cloneHeader.amount * 100
      return cloneHeader;
    },
    // 外部调用，验证必填的输入框是否都有填写
    getValid() {
      this.$refs.workOrderHeaderFormRef.validate((valid) => {
        this.valid = valid;
      });
      return this.valid;
    },
    // 只能输入数字并且保留两位小数
    handleInput2(e) {
      /* 先屏蔽掉 输入检测，改成 给后台的接口强制四舍五入2位小数。
                // 通过正则过滤小数点后两位
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
                */
    },

    // 幅宽  300x200x100 只能输入 数字 和 x
    handleInput_combs(e) {
      e.target.value = e.target.value.replace(/[^\dx]/g, "") || null;
    },

    // 需要重新计算 '理论重量'。理论重量 = 总幅宽(AxB)*目标产量(C)*平方克重(D) = (A+B)/100*C*D/1000
    meterWeightCountChange() {
      //重新取 幅宽.  500x400x300x200x100
      let arr = this.workOrderHeader.combs.split("x"); //最多取5个。
      let arrSum = 0;
      for (let i = 0; i < arr.length; i++) {
        arrSum = arrSum + Number(arr[i]);
        
      }
      // console.log('arrSum=', arrSum)
      console.log(arr.length);
      this.$set(this.workOrderHeader,'combsCount',arr.length)
      // this.workOrderHeader.combsCount = arr.length;
      //重新取 目标产量 和 平方克重，计算。
      this.workOrderHeader.predictWeight =
        (((arrSum / 100) *
          this.workOrderHeader.predictProducedLength *
          this.workOrderHeader.squareGrams) /
        1000).toFixed(2);
    },
    meterWeightCountChange2() {
      let arr = this.workOrderHeader.combs.split("x", 5); //最多取5个。
      let arrSum = 0;
      for (let i = 0; i < arr.length; i++) {
        arrSum = arrSum + Number(arr[i]);
      }
      this.workOrderHeader.predictProducedLength =
        ((this.workOrderHeader.predictWeight * 100 * 1000) /
        (arrSum * this.workOrderHeader.squareGrams)).toFixed(2);
    },

    // 设置表头信息
    setworkOrderHeader(response, type) {
      this.workOrderHeader = this.formatworkOrderHeader(response, type);

      //解决bug: "选择胚布"按钮 只能首次生效，第2次之后点击，editbox数据无法刷新。
      this.$set(this.workOrderHeader, "name_change", response.craftsheet.name); //物料名称
      this.$set(
        this.workOrderHeader,
        "number_change",
        response.craftsheet.number
      ); //物料编号
    },
    // 格式化表单信息
    formatworkOrderHeader(res, type) {
      (res.createTime = new Date().getTime()), // 创建时间/制单日期 220405 liuqy: 不可编辑，提交时自动生成。
        // res.department = '生产部' // 暂时先固定为 '生产部'.
        (res.selectDepartment = "生产部"); // 暂时先固定为 '生产部'.----注意这个
      res.density = Number(res.density).toFixed(2); // 浮点数强制显示2位小数。
      res.predictWeight = Number(res.predictWeight/1000).toFixed(2); // 浮点数强制显示2位小数。
      res.nowProducedLength = Number(res.nowProducedLength).toFixed(2); // 浮点数强制显示2位小数。
      // res.predictProducedLength = Number(res.predictProducedLength).toFixed(2);
      res.nowWeight = Number(res.nowWeight).toFixed(2);
      switch (type) {
        case 2: // 复制
          res.number = ""; // 复制时 要清除工单编号。（自动生成)
          res.nowProducedLength = 0;
          // 因为 必填项 不能跨对象，所以要把 '胚布编号' 和 '胚布名称' 抢救回来。-注意要用上面的set
          // res.number_change = res.craftsheet.number // 胚布编号
          // res.name_change = res.craftsheet.name // 胚布名称
          break;

        case 1: // 编辑
          // 因为 必填项 不能跨对象，所以要把 '胚布编号' 和 '胚布名称' 抢救回来。-注意要用上面的set
          //res.number_change = res.craftsheet.number // 胚布编号
          //res.name_change = res.craftsheet.name // 胚布名称
          break;

        case 0: // 新建
        default:
          break;
      }
      // 后台是按整数(厘米)存储，前端要转换成米。
      res.predictProducedLength = Number(res.predictProducedLength/100).toFixed(2); //目标产量(米)
      res.dropClothLength = Number(res.dropClothLength / 100); //匹长(米)

      res.speed = Number(res.speed).toFixed(2); // 浮点数强制显示2位小数。
      res.squareGrams = Number(res.squareGrams).toFixed(2); // 浮点数强制显示2位小数。

      // status 0=审核不通过(待提交), 1=未审核(待审), 2=已审核(已审) 。变换成文字显示。
      if (res.status === 2) {
        res.status_change = "已审";
      } else if (res.status === 1) {
        res.status_change = "待审";
      } else {
        // 0 或者 null
        res.status_change = "待提交";
      }

      res.threadCount = Number(res.threadCount).toFixed(2); // 浮点数强制显示2位小数。

      // workStatus 上机状态
      // 0 = 准备中  ---->添加工单时，不显示。
      // 1 = 待产    ---->提交工单后，显示 "等待"。
      // 3 = 生产中  ---->点击上单后，显示 "上单"="上机"
      // 2 = 暂停    ---->点击下单后，显示 "下单"="下机"
      // 4 = 完成    ---->点击结案后，显示 "结案"
      if (res.workStatus === 1) {
        res.workStatus_change = "等待";
      } else if (res.workStatus === 2) {
        res.workStatus_change = "下机";
      } else if (res.workStatus === 3) {
        res.workStatus_change = "上机";
      } else if (res.workStatus === 4) {
        res.workStatus_change = "结案";
      } else {
        // 0 或者 null
        res.workStatus_change = "准备中";
      }

      return res;
    },

    //选择胚布对话框 返回的处理
    updatePeiBuDialog() {
      let selectedPeiBu = this.$refs.materialSelect.getPeiBuInfo();
      // console.log('selectedPeiBu=', selectedPeiBu)

      // hcy: $nextTick()下个周期立即刷新页面.
      this.$nextTick(() => {
        //注意这里 不能直接赋值，要用 set强制刷新。
        // this.workOrderHeader.materialId = selectedPeiBu.materialId //物料ID
        // this.workOrderHeader.name_change = selectedPeiBu.name //物料名称
        // this.workOrderHeader.number_change = selectedPeiBu.number //物料编号
        this.$set(this.workOrderHeader, "materialId", selectedPeiBu.materialId); //物料ID
        this.$set(this.workOrderHeader, "name_change", selectedPeiBu.name); //物料名称
        this.$set(this.workOrderHeader, "number_change", selectedPeiBu.number); //物料编号
      });

      //通知父组件 '选择胚布' 已经成功。
      this.$emit("selectPeiBuFinish", selectedPeiBu);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 0 12px 0 0;
  width: 80px !important;
  box-sizing: border-box;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  height: 40px;
}
</style>
